import logo1 from '../../assets/logo1.jpg';
import logo2 from '../../assets/logo2.jpg';
import audio1 from '../../assets/The_House_Of_Bohemian_Champions_Mashup.mp3';
import audio2 from '../../assets/A_Sky_Full_Of_Stars.mp3';

import Boom from '../../assets/effects/Boom.mp3';
import Horn1 from '../../assets/effects/Horn1.mp3';
import HornBlast from '../../assets/effects/HornBlast.mp3';
import LetsGo from '../../assets/effects/LetsGo.mp3';
import Pitbull from '../../assets/effects/Pitbull.mp3';
import PoliceSirenLong from '../../assets/effects/PoliceSirenLong.mp3';
import Siren from '../../assets/effects/Siren.mp3';
import Wheelout from '../../assets/effects/Wheelout.mp3';

import * as actionTypes from '../actions/actionTypes';

const soundEffects = [Boom, Horn1, HornBlast, Wheelout, LetsGo, Pitbull, PoliceSirenLong, Siren];
const effectNames = ['Boom', 'Horn 1', 'Horn Blast', 'Wheelout', 'Lets Go', 'Pitbull Count', 'Police Siren', 'Siren'];

function initEffectsToState() {
    return soundEffects.map((x, index) => {
        return {
            key: index,
            file: x,
            name: effectNames[index],
            playing: false,
            effectRef: null,
            pizzicatoAudio: null
        }
    })
}


const initialState = {
    audios: {
        '0': {
            id: 0,
            name: 'House Of Bohemian Champions',
            artist: 'Queen | Dmitri Vegas & Like Mike',
            file: audio1,
            progressBarPosition: 0,
            audioLength: 0,
            playingStatus: "STOPPED",
            intervalId: null,
            duration: 0.0,
            audioRef: null,
            volume: 100,
            pannerValue: 0,
            playbackRate: 1,
            logo: logo1,
            pizzicatoAudio: null,
            distortion: 0,
            lowPassFilter: {
                frequency: 22050,
                peak: 1
            },
            delayMix: 0
        },
        '1': {
            id: 1,
            name: 'A Sky Full of Stars',
            artist: 'Coldplay',
            duration: 0.0,
            file: audio2,
            progressBarPosition: 0,
            playingStatus: "STOPPED",
            intervalId: null,
            audioLength: 0,
            audioRef: null,
            volume: 100,
            pannerValue: 0,
            playbackRate: 1,
            logo: logo2,
            pizzicatoAudio: null,
            distortion: 0,
            lowPassFilter: {
                frequency: 22050,
                peak: 1
            },
            delayMix: 0
        }
    },
    effects: initEffectsToState(),
    loading: false,
    mainPannerValue: 0
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_AUDIOS:
            break;
        case actionTypes.SET_AUDIOS:
            return {
                ...state,
                audios: action.audios
            }
        case actionTypes.SET_SOUND_EFFECTS:
            return {
                ...state,
                effects: action.effects
            }
        case actionTypes.LOADING_START:
            return {
                ...state,
                loading: true
            }
        case actionTypes.LOADING_DONE:
            return {
                ...state,
                loading: false
            }
        case actionTypes.UPDATE_VOLUME:
            let updatedVolume = action.volume_value === 0 ? 0 : (action.volume_value / 100).toFixed(2);
            let aud = {...state.audios[action.index]};
            const pizzAudio = aud.pizzicatoAudio;
            pizzAudio.volume = parseFloat(updatedVolume);
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        volume: action.volume_value,
                        pizzicatoAudio: pizzAudio
                    }
                }
            }
        case actionTypes.UPDATE_DISTORTION:
            let updatedValue = action.value === 0 ? 0 : Number((action.value / 100).toFixed(1));
            let dis_aud = {...state.audios[action.index]};
            const dis_pizzAudio = dis_aud.pizzicatoAudio;
            dis_pizzAudio.effects[0].gain = updatedValue;
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        distortion: action.value,
                        pizzicatoAudio: dis_pizzAudio
                    }
                }
            }
        case actionTypes.UPDATE_DELAY_MIX:
            let updatedValueRing = action.value === 0 ? 0 : Number((action.value / 100).toFixed(1));
            let Ring_aud = {...state.audios[action.index]};
            const Ring_pizzAudio = Ring_aud.pizzicatoAudio;
            Ring_pizzAudio.effects[2].mix = updatedValueRing;
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        delayMix: action.value,
                        pizzicatoAudio: Ring_pizzAudio
                    }
                }
            }
        case actionTypes.UPDATE_FREQUENCY:
            let freq_Value = action.value === 0 ? 0 : Number((action.value).toFixed());
            let freq_aud = {...state.audios[action.index]};
            const freq_pizzAudio = freq_aud.pizzicatoAudio;
            freq_pizzAudio.effects[1].frequency = freq_Value;
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        lowPassFilter: {
                            ...state.audios[action.index].lowPassFilter,
                            frequency: freq_Value
                        },
                        pizzicatoAudio: freq_pizzAudio
                    }
                }
            }
        case actionTypes.PROGRESSBAR_CHANGE:
            let freshAudio = state.audios[action.index];
            if (freshAudio.playingStatus === "PLAYING") {
                freshAudio.pizzicatoAudio.pause();
                freshAudio.pizzicatoAudio.play(0, action.value);

            }
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        progressBarPosition: action.value
                    }
                }
            }
        case actionTypes.PROGRESSBAR_INCREMENT:
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        progressBarPosition: action.value
                    }
                }
            }
        case actionTypes.PLAY_AUDIO:
            let pos = action.pos === null ? 0 : action.pos;
            if (state.audios[action.index].playingStatus === "PLAYING")
                state.audios[action.index].pizzicatoAudio.pause();
            state.audios[action.index].pizzicatoAudio.play(0, pos);
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        playingStatus: "PLAYING",
                        intervalId: action.intervalId
                    }
                }
            }
        case actionTypes.PLAY_SOUND_EFFECT:
            let effect_pos = 0;
            if (state.effects[action.index].playing === true)
                state.effects[action.index].pizzicatoAudio.pause();
            state.effects[action.index].pizzicatoAudio.play(0, effect_pos);
            let updatedEffects = state.effects.map((effect, index) => {
                if (index === action.index) {
                    return {
                        ...effect,
                        playing: true
                    }
                } else {
                    return {
                        ...effect
                    }
                }
            })
            return {
                ...state,
                effects: updatedEffects

            }
        case actionTypes.STOP_SOUND_EFFECT:
            state.effects[action.index].pizzicatoAudio.stop();
            let stopUpdatedEffects = state.effects.map((effect, index) => {
                if (index === action.index) {
                    return {
                        ...effect,
                        playing: false
                    }
                } else {
                    return {
                        ...effect
                    }
                }
            })
            return {
                ...state,
                effects: stopUpdatedEffects

            }
        case actionTypes.PAUSE_AUDIO:
            state.audios[action.index].pizzicatoAudio.pause();
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        playingStatus: "PAUSED",
                        progressBarPosition: action.pos,
                        intervalId: null
                    }
                }
            }
        case actionTypes.STOP_AUDIO:
            state.audios[action.index].pizzicatoAudio.stop();
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.index]: {
                        ...state.audios[action.index],
                        playingStatus: "STOPPED",
                        progressBarPosition: 0,
                        intervalId: null
                    }
                }
            }
        case actionTypes.CHANGE_PANNER:
            const audio1 = {...state.audios[0]};
            const audio2 = {...state.audios[1]};

            let value = action.value.toFixed(2);

            let vol1 = audio1.volume;
            let vol2 = audio2.volume;
            if (value > 0) {
                let updateVolume = vol1 - (vol1 * (value / 100));
                updateVolume = updateVolume / 100;
                let pizAud = audio1.pizzicatoAudio;
                pizAud.volume = updateVolume
                return {
                    ...state,
                    audios: {
                        ...state.audios,
                        '0': {
                            ...state.audios[0],
                            pizzicatoAudio: pizAud
                        }
                    },
                    mainPannerValue: value
                }
            } else if (value < 0) {
                let updateVolume = vol2 + (vol2 * (value / 100));
                updateVolume = updateVolume / 100;
                let pizAud = audio2.pizzicatoAudio;
                pizAud.volume = updateVolume
                return {
                    ...state,
                    audios: {
                        ...state.audios,
                        '1': {
                            ...state.audios[1],
                            pizzicatoAudio: pizAud
                        }
                    },
                    mainPannerValue: value
                }
            } else {
                let pizAud1 = audio1.pizzicatoAudio;
                pizAud1.volume = vol1
                let pizAud2 = audio2.pizzicatoAudio;
                pizAud2.volume = vol2
                return {
                    ...state,
                    audios: {
                        ...state.audios,
                        '0': {
                            ...state.audios[0],
                            pizzicatoAudio: pizAud1
                        },
                        '1': {
                            ...state.audios[1],
                            pizzicatoAudio: pizAud2
                        }
                    },
                    mainPannerValue: value
                }
            }
        case actionTypes.AUDIO_CHANGE:
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.audioIndex]: {
                        ...state.audios[action.audioIndex],
                        file: action.newFile,
                        artist: "Unknown Artist",
                        name: action.name,
                        pizzicatoAudio: action.pizzicatoAudio,
                        distortion: 0,
                        delayMix: 0,
                        lowPassFilter: {
                            ...state.audios[action.audioIndex].lowPassFilter,
                            frequency: 22050
                        },

                    }
                }
            }
        case actionTypes.DURATION_CHANGE:
            return {
                ...state,
                audios: {
                    ...state.audios,
                    [action.audioIndex]: {
                        ...state.audios[action.audioIndex],
                        duration: action.newDuration,
                        audioLength: action.audioLength
                    }
                }
            }
        default:
            return state;
    }
}

export default reducer;